module.exports = __webpack_public_path__ + "static/media/orascom.82ef582f.png";